export default {
  // Home page, basic <title> and <description>
  appName: 'Zocial',
  appDescription: 'A minimalistic opinionated Mastodon web client.',
  homeDescription: `
    <p>
      A minimalistic opinionated Mastodon web client.
    </p>`,
  homeMultiInstance: `
    <p>
      Get started by logging in to an instance:
    </p>`,
  logIn: 'Log in',
  footer: `
    <p>
      Powered by <a rel="noopener" target="_blank" href="https://ztfr.eu">Zeitfresser</a> · <a href="/settings/about#donations" rel="prefetch">Donations</a> · <a href="/settings/about#privacy-policy" rel="prefetch">Privacy Policy</a> · <a rel="noopener" target="_blank" href="https://git.ztfr.eu/Dome/Zocial/releases">Zocial v{version}</a>
    </p>
  `,
  // Manifest
  newStatus: 'New post',
  // Generic UI
  loading: 'Loading',
  okay: 'OK',
  cancel: 'Cancel',
  alert: 'Alert',
  close: 'Close',
  error: 'Error: {error}',
  errorShort: 'Error:',
  account: 'Account',
  start: 'Start',
  stop: 'Stop',
  // Relative timestamps
  justNow: 'just now',
  // Navigation, page titles
  navItemLabel: `
    {label} {selected, select,
      true {(current page)}
      other {}
    } {name, select,
      notifications {{count, plural,
        =0 {}
        one {(1 notification)}
        other {({count} notifications)}
      }}
      community {{count, plural,
        =0 {}
        one {(1 follow request)}
        other {({count} follow requests)}
      }}
      other {}
    }
  `,
  blockedUsers: 'Blocked users',
  bookmarks: 'Bookmarks',
  directMessages: 'Direct messages',
  favorites: 'Favorites',
  reactions: 'Reactions',
  federated: 'Federated',
  bubble: 'Bubble',
  home: 'Home',
  local: 'Local',
  notifications: 'Notifications',
  mutedUsers: 'Muted users',
  pinnedStatuses: 'Pinned posts',
  followRequests: 'Follow requests',
  followRequestsLabel: `Follow requests {hasFollowRequests, select,
    true {({count})}
    other {}
  }`,
  list: 'List',
  search: 'Search',
  pageHeader: 'Page header',
  goBack: 'Go back',
  back: 'Back',
  profile: 'Profile',
  federatedTimeline: 'Federated timeline',
  bubbleTimeline: 'Bubble timeline',
  localTimeline: 'Local timeline',
  // community page
  community: 'Community',
  pinnableTimelines: 'Pinnable timelines',
  timelines: 'Timelines',
  lists: 'Lists',
  instanceSettings: 'Instance settings',
  notificationMentions: 'Notification mentions',
  profileWithMedia: 'Profile with media',
  profileWithReplies: 'Profile with replies',
  hashtag: 'Hashtag',
  // not logged in
  profileNotLoggedIn: 'A user timeline will appear here when logged in.',
  bookmarksNotLoggedIn: 'Your bookmarks will appear here when logged in.',
  directMessagesNotLoggedIn: 'Your direct messages will appear here when logged in.',
  favoritesNotLoggedIn: 'Your favorites will appear here when logged in.',
  federatedTimelineNotLoggedIn: 'Your federated timeline will appear here when logged in.',
  bubbleTimelineNotLoggedIn: 'Your bubble timeline will appear here when logged in.',
  bubbleTimelineNotSupported: 'The bubble timeline isn\'t supported by your instance.',
  localTimelineNotLoggedIn: 'Your local timeline will appear here when logged in.',
  searchNotLoggedIn: 'You can search once logged in to an instance.',
  communityNotLoggedIn: 'Community options appear here when logged in.',
  listNotLoggedIn: 'A list will appear here when logged in.',
  notificationsNotLoggedIn: 'Your notifications will appear here when logged in.',
  notificationMentionsNotLoggedIn: 'Your notification mentions will appear here when logged in.',
  statusNotLoggedIn: 'A thread will appear here when logged in.',
  tagNotLoggedIn: 'A hashtag timeline will appear here when logged in.',
  accountNotLoggedIn: 'Account settings will appear here when logged in.',
  // Shown as the collapse/warning text for posts matching a "hide with a warning" word filter
  filtered: 'Filtered',
  // Notification subpages
  filters: 'Filters',
  all: 'All',
  mentions: 'Mentions',
  // Follow requests
  approve: 'Approve',
  reject: 'Reject',
  // Hotkeys
  hotkeys: 'Hotkeys',
  global: 'Global',
  timeline: 'Timeline',
  media: 'Media',
  globalHotkeys: `
    {leftRightChangesFocus, select,
      true {
        <li><kbd>→</kbd> to go to the next focusable element</li>
        <li><kbd>←</kbd> to go to the previous focusable element</li>
      }
      other {}
    }
    <li>
      <kbd>1</kbd> - <kbd>6</kbd>
      {leftRightChangesFocus, select,
        true {}
        other {or <kbd>←</kbd>/<kbd>→</kbd>}
      }
      to switch columns
    </li>
    <li><kbd>7</kbd> or <kbd>c</kbd> to compose a new post</li>
    <li><kbd>s</kbd> or <kbd>/</kbd> to search</li>
    <li><kbd>g</kbd> + <kbd>h</kbd> to go home</li>
    <li><kbd>g</kbd> + <kbd>n</kbd> to go to notifications</li>
    <li><kbd>g</kbd> + <kbd>l</kbd> to go to the local timeline</li>
    <li><kbd>g</kbd> + <kbd>b</kbd> to go to the bubble timeline</li>
    <li><kbd>g</kbd> + <kbd>t</kbd> to go to the federated timeline</li>
    <li><kbd>g</kbd> + <kbd>c</kbd> to go to the community page</li>
    <li><kbd>g</kbd> + <kbd>d</kbd> to go to the direct messages page</li>
    <li><kbd>g</kbd> + <kbd>i</kbd> to go to the instances page</li>
    <li><kbd>h</kbd> or <kbd>?</kbd> to toggle the help dialog</li>
    <li><kbd>Backspace</kbd> to go back, close dialogs</li>
  `,
  timelineHotkeys: `
    <li><kbd>j</kbd> or <kbd>↓</kbd> to activate the next post</li>
    <li><kbd>k</kbd> or <kbd>↑</kbd> to activate the previous post</li>
    <li><kbd>.</kbd> to show more and scroll to top</li>
    <li><kbd>o</kbd> to open</li>
    <li><kbd>f</kbd> to favorite</li>
    <li><kbd>b</kbd> to boost</li>
    <li><kbd>r</kbd> to reply</li>
    <li><kbd>e</kbd> to edit your own posts</li>
    <li><kbd>q</kbd> to quote a post, if supported</li>
    <li><kbd>Escape</kbd> to close reply</li>
    <li><kbd>a</kbd> to bookmark</li>
    <li><kbd>i</kbd> to open images, video, or audio</li>
    <li><kbd>y</kbd> to show or hide sensitive media</li>
    <li><kbd>m</kbd> to mention the author</li>
    <li><kbd>p</kbd> to open the author's profile</li>
    <li><kbd>l</kbd> to open the card's link in a new tab</li>
    <li><kbd>x</kbd> to show or hide text behind content warning</li>
    <li><kbd>z</kbd> to show or hide all content warnings in a thread</li>
    <li><kbd>t</kbd> to translate a post</li>
  `,
  mediaHotkeys: `
    <li><kbd>←</kbd> / <kbd>→</kbd> to go to next or previous</li>
  `,
  // Community page, tabs
  tabLabel: `{label} {current, select,
    true {(Current)}
    other {}
  }`,
  pageTitle: `
    {hasNotifications, select,
      true {({count})}
      other {}
    }
    {name}
    ·
    {showInstanceName, select,
      true {{instanceName}}
      other {{appName}}
    }
  `,
  pinLabel: `{label} {pinnable, select,
    true {
      {pinned, select,
        true {(Pinned page)}
        other {(Unpinned page)}
      }
    }
    other {}
  }`,
  pinPage: 'Pin {label}',
  // Status composition
  composeStatus: 'Compose post',
  postStatus: 'Post',
  contentWarning: 'Content warning',
  dropToUpload: 'Drop to upload',
  invalidFileType: 'Invalid file type',
  composeLabel: "What's on your mind?",
  autocompleteDescription: 'When autocomplete results are available, press up or down arrows and enter to select.',
  mediaUploads: 'Media uploads',
  edit: 'Edit',
  delete: 'Delete',
  description: 'Description',
  descriptionLabel: 'Describe for visually impaired (image, video) or auditorily impaired (audio, video) people',
  markAsSensitive: 'Mark media as sensitive',
  // Polls
  youVotedFor: 'You voted for',
  createPoll: 'Create poll',
  removePollChoice: 'Remove choice {index}',
  pollChoiceLabel: 'Choice {index}',
  multipleChoice: 'Multiple choice',
  pollDuration: 'Poll duration',
  fiveMinutes: '5 minutes',
  thirtyMinutes: '30 minutes',
  oneHour: '1 hour',
  sixHours: '6 hours',
  twelveHours: '12 hours',
  oneDay: '1 day',
  threeDays: '3 days',
  sevenDays: '7 days',
  fourteenDays: '14 days',
  thirtyDays: '30 days',
  oneYear: '1 year',
  never: 'Never',
  addEmoji: 'Insert emoji',
  addMedia: 'Add media (images, video, audio)',
  addPoll: 'Add poll',
  removePoll: 'Remove poll',
  postPrivacyLabel: 'Change post privacy (currently {label})',
  addContentWarning: 'Add content warning',
  removeContentWarning: 'Remove content warning',
  schedulePost: 'Schedule post',
  removeSchedule: 'Remove schedule',
  scheduleSet: 'Schedule',
  scheduleDateTimeLabel: 'Send at',
  scheduleTooSoon: 'Scheduled time must be at least 5 minutes from now',
  scheduledStatusCreated: 'Post scheduled',
  scheduledPosts: 'Scheduled posts',
  noScheduledPosts: 'No scheduled posts',
  cancelScheduledPost: 'Cancel',
  rescheduleLabel: 'Reschedule',
  scheduledPostCancelled: 'Scheduled post cancelled',
  scheduledPostRescheduled: 'Rescheduled',
  altLabel: 'Describe for visually impaired people',
  extractText: 'Extract text from image',
  extractingText: 'Extracting text…',
  extractingTextCompletion: 'Extracting text ({percent}% complete)…',
  unableToExtractText: 'Unable to extract text.',
  // Account options
  followAccount: 'Follow {account}',
  unfollowAccount: 'Unfollow {account}',
  blockAccount: 'Block {account}',
  unblockAccount: 'Unblock {account}',
  muteAccount: 'Mute {account}',
  unmuteAccount: 'Unmute {account}',
  showReblogsFromAccount: 'Show boosts from {account}',
  hideReblogsFromAccount: 'Hide boosts from {account}',
  backfill: 'Load missing posts',
  showDomain: 'Unblock {domain}',
  hideDomain: 'Block {domain}',
  reportAccount: 'Report {account}',
  mentionAccount: 'Mention {account}',
  copyLinkToAccount: 'Copy link to account',
  copiedToClipboard: 'Copied to clipboard',
  createList: 'Create list',
  unableToCreateList: 'Unable to create list: {error}',
  listTitle: 'List title',
  manageLists: 'Manage lists',
  rename: 'Rename',
  listExclusive: 'Show posts only in this list',
  listExclusiveHelp: 'Members of this list won’t appear in your home timeline.',
  listExclusiveNotSupported: 'This server doesn’t support exclusive lists.',
  deleteListTitle: 'Delete “{title}”?',
  deleteListConfirm: 'This deletes the list “{title}”. The accounts in it are not affected; if it was exclusive, their posts return to your home timeline.',
  deletedList: 'List deleted.',
  unableToRenameList: 'Unable to rename list: {error}',
  unableToUpdateList: 'Unable to update list: {error}',
  unableToDeleteList: 'Unable to delete list: {error}',
  manageInLists: 'Manage list memberships',
  listMembership: 'List memberships for {account}',
  noListsYet: 'No lists yet',
  errorInListMembership: 'Error updating list membership',
  listMembershipNotSupported: 'Not supported by this server',
  // Media dialog
  navigateMedia: 'Navigate media items',
  showPreviousMedia: 'Show previous media',
  showNextMedia: 'Show next media',
  enterPinchZoom: 'Pinch-zoom mode',
  exitPinchZoom: 'Exit pinch-zoom mode',
  showMedia: `Show {index, select,
    1 {first}
    2 {second}
    3 {third}
    other {fourth}
  } media {current, select,
    true {(current)}
    other {}
  }`,
  previewFocalPoint: 'Preview (focal point)',
  enterFocalPoint: 'Enter the focal point (X, Y) for this media',
  muteNotifications: 'Mute notifications as well',
  muteAccountConfirm: 'Mute {account}?',
  mute: 'Mute',
  unmute: 'Unmute',
  zoomOut: 'Zoom out',
  zoomIn: 'Zoom in',
  // Reporting
  reportingLabel: 'You are reporting {account} to the moderators of {instance}.',
  additionalComments: 'Additional comments',
  forwardDescription: 'Forward to the moderators of {instance} as well?',
  forwardLabel: 'Forward to {instance}',
  unableToLoadStatuses: 'Unable to load recent posts: {error}',
  report: 'Report',
  noContent: '(No content)',
  noStatuses: 'No posts to report',
  // Status options
  unpinFromProfile: 'Unpin from profile',
  pinToProfile: 'Pin to profile',
  muteConversation: 'Mute conversation',
  unmuteConversation: 'Unmute conversation',
  bookmarkStatus: 'Bookmark post',
  unbookmarkStatus: 'Unbookmark post',
  deleteAndRedraft: 'Delete and redraft',
  reportStatus: 'Report post',
  translateStatus: 'Translate post',
  translated: `Translated post from {from}{detected, select,
    true { - Detected}
    other {}
  }`,
  translation: 'Translation',
  translationTargetLanguage: 'Translation language',
  translationBrowserDefault: 'Browser default',
  translationLanguageUnavailable: 'Language list unavailable — translation language follows browser default',
  translateError: 'There was an error translating this post',
  translateRateLimit: 'You hit the rate limit for translations',
  translateUnsupportedLanguage: 'This language is currently not supported',
  alreadyInTargetLanguage: 'Post is already in your language',
  translating: 'Translating...',
  hideTranslation: 'Hide translation',
  reactToStatus: 'React to post',
  quoteStatus: 'Quote post',
  shareStatus: 'Share post',
  copyLinkToStatus: 'Copy link to post',
  // Account profile
  profileForAccount: 'Profile for {account}',
  statisticsAndMoreOptions: 'Stats and more options',
  statuses: 'Posts',
  follows: 'Follows',
  followers: 'Followers',
  joined: 'Joined',
  postingStatsSummary: 'Last {posts} in the past {duration}',
  postingStatsPosts: '{total, plural, one {# post} other {# posts}}',
  postingStatsDays: '{days, plural, one {# day} other {# days}}',
  postingStatsYears: '{years, plural, one {# year} other {# years}}',
  postingStatsOriginal: 'Original',
  postingStatsReplies: 'Replies',
  postingStatsBoosts: 'Boosts',
  postingStatsOriginalTitle: '{count, plural, one {# original post} other {# original posts}} ({percent})',
  postingStatsRepliesTitle: '{count, plural, one {# reply} other {# replies}} ({percent})',
  postingStatsBoostsTitle: '{count, plural, one {# boost} other {# boosts}} ({percent})',
  scrollToTopOfConversation: 'Scroll to top of conversation',
  scrollToTop: 'Scroll to top',
  moreOptions: 'More options',
  followersLabel: 'Followed by {count}',
  followingLabel: 'Follows {count}',
  followLabel: 'Follow',
  unfollowLabel: 'Unfollow',
  unrequestLabel: 'Cancel request',
  unfollowingLabel: 'Unfollowing...',
  unblockingLabel: 'Unblocking...',
  unrequestingLabel: 'Canceling...',
  requestingLabel: 'Requesting...',
  notify: 'Subscribe to {account}',
  denotify: 'Unsubscribe from {account}',
  subscribedAccount: 'Subscribed to account',
  unsubscribedAccount: 'Unsubscribed from account',
  unblock: 'Unblock',
  nameAndFollowing: 'Name and following',
  clickToSeeAvatar: 'Click to see avatar',
  opensInNewWindow: '{label} (opens in new window)',
  blocked: 'Blocked',
  domainHidden: 'Domain blocked',
  muted: 'Muted',
  followsYou: 'Follows you',
  locked: 'This account is locked. The owner manually reviews who can follow them.',
  avatarForAccount: 'Avatar for {account}',
  fields: 'Fields',
  accountHasMoved: '{account} has moved:',
  profilePageForAccount: 'Profile page for {account}',
  verified: 'Verified',
  // About page
  about: 'About',
  aboutApp: 'About Zocial',
  aboutAppDescription: `
  <p>
    Zocial is <a rel="noopener" target="_blank" href="https://git.ztfr.eu/Dome/Zocial">open-source</a> software and a fork of <a rel="noopener" target="_blank" href="https://github.com/enafore/enafore">Enafore</a>, created by <a rel="noopener" target="_blank" href="https://social.ztfr.eu/@dome">Dome</a>.
  </p>

  <h2 id="privacy-policy">Privacy Policy</h2>

  <p>
    Zocial does not store any personal information on its servers, including but not limited to names, email addresses, IP addresses, posts, and photos.
  </p>

  <p>
    Zocial is a static site which can be hosted anywhere (e.g. GitHub Pages). It is provided as a <a rel="noopener" target="_blank" href="https://hub.docker.com/r/domoel/zocial">Docker Image</a> and can be deployed using an nginx web  server. All data is stored locally in your browser and shared with the fediverse instance(s) you connect to.
  </p>

  <h2>Translations</h2>

  <p>
    Post translation is powered by <a rel="noopener" target="_blank" href="https://libretranslate.com">LibreTranslate</a> — an open-source translation engine with no Google dependency. Requests are routed through the server, so no translation service is ever contacted directly from your browser. Self-hosting is supported via the <code>TRANSLATE_API</code> environment variable.
  </p>

  <h2>Usage of AI</h2>

  <p>
    This project is AI supported. However, its development follows a rigorous <a rel="noopener" target="_blank" href="https://git.ztfr.eu/Dome/Zocial/src/branch/main/docs/Architecture.md">design philosophy</a> and strict programming principles, and great care is taken when implementing new features. The code is reviewed on a regular basis.
  </p>

  <h2>Credits</h2>

  <p>
    Icons provided by <a rel="noopener" target="_blank" href="http://fontawesome.io/">Font Awesome</a>.
  </p>

  <h2>Licence</h2>

  <p>
    Zocial is licensed under the <a rel="noopener" target="_blank" href="https://git.ztfr.eu/Dome/Zocial/src/branch/main/LICENSE">GNU Affero General Public License</a>. Powered by <a rel="noopener" target="_blank" href="https://ztfr.eu/">Zeitfresser</a>
  </p>

  <h2 id="donations">Donations</h2>

  <p>
    Zocial is a non-profit project and free to use. Donations are entirely optional — they simply help cover the running costs of the public instance (domain and hosting).
  </p>

  <p>
    If you'd like to support it: <a rel="noopener" target="_blank" href="https://www.paypal.com/donate/?hosted_button_id=QMWFH4FDXN66C">Donate via PayPal</a>.
  </p>

  <h2>Support &amp; Development</h2>

  <p>
    See the <a rel="noopener" target="_blank" href="https://git.ztfr.eu/Dome/Zocial/src/branch/main/docs/User-Guide.md">user guide</a> for general usage and the <a rel="noopener" target="_blank" href="https://git.ztfr.eu/Dome/Zocial/src/branch/main/docs/Admin-Guide.md">admin guide</a> if your instance has trouble connecting. If you want to understand the underlying architecture and the decision rationale behind Zocial, just check out the <a rel="noopener" target="_blank" href="https://git.ztfr.eu/Dome/Zocial/src/branch/main/docs/Architecture.md">architecture Handbook</a>.
  </p>

  <p>
    For further support or to participate in development, join the <a rel="noopener" target="_blank" href="https://ztfr.eu/matrix">Zeitfresser Matrix Community</a> or the <a rel="noopener" target="_blank" href="https://look.ztfr.eu/#/#support:ztfr.eu">Development &amp; Support Channel</a>.
  </p>

  <h2>Version</h2>

  <p>
    You are running Zocial version <code class="zocial-version"></code>.
  </p>`,
  logs: 'Logs',
  showAllLogs: 'Show all logs (debug & info)',
  showAllLogsHint: 'By default only warnings and errors are shown. Turn this on to also include debug and info logs.',
  copyLogs: 'Copy logs',
  logsCopied: 'Logs copied to clipboard',
  logsCopyFailed: 'Could not copy logs',
  clearLogs: 'Clear logs',
  clearLogsConfirm: 'Clear all logs? This cannot be undone.',
  logsCleared: 'Logs cleared',
  // Settings
  settings: 'Settings',
  general: 'General',
  generalSettings: 'General settings',
  generalSettingsLoginRequired: 'General settings are only available when logged in.',
  showSensitive: 'Show sensitive media by default',
  showAllSpoilers: 'Expand content warnings by default',
  showPlain: 'Show a plain gray color for sensitive media',
  allSensitive: 'Treat all media as sensitive',
  largeMedia: 'Show large inline images and videos',
  autoplayGifs: 'Autoplay animated GIFs',
  hideCards: 'Hide link preview cards',
  underlineLinks: 'Underline links in posts and profiles',
  accessibility: 'Accessibility',
  reduceMotion: 'Reduce motion in UI animations',
  disableTappable: 'Disable tappable area on entire post',
  removeEmoji: 'Remove emoji from user display names',
  shortAria: 'Use short article ARIA labels',
  announceCardDescriptionsPre: 'Announce link preview',
  announceCardDescriptionsText: 'descriptions',
  announceCardDescriptionsDescription: `The title of a link preview card is always included in screen reader announcements. \
Enable this to also include the description text below the title.`,
  announceCardDescriptionsPost: '',
  theme: 'Theme',
  themeForInstance: 'Theme for {instance}',
  disableCustomScrollbars: 'Disable custom scrollbars',
  bottomNav: 'Place the navigation bar at the bottom of the screen',
  centerNav: 'Center the navigation bar',
  preferences: 'Preferences',
  hotkeySettings: 'Hotkey settings',
  disableHotkeys: 'Disable all hotkeys',
  leftRightArrows: 'Left/right arrow keys change focus rather than columns/media',
  guide: 'Guide',
  reload: 'Reload',
  disableFollowRequestCount: 'Hide follow request count',
  hideLongPosts: 'Collapse long posts without content warnings',
  longPostLengthLabel: 'Collapse threshold (characters)',
  // Wellness settings
  wellness: 'Wellness',
  wellnessDescription: `Wellness settings are designed to reduce the addictive or anxiety-inducing aspects of social media.
    Choose any options that work well for you.`,
  enableAll: 'Enable all',
  metrics: 'Metrics',
  hideFollowerCount: 'Hide follower counts (capped at 10)',
  hideReblogCount: 'Hide boost counts',
  enableThreadPolling: 'Show auto-refresh button in threads',
  defaultUnlistedReplies: 'Default replies to unlisted visibility',
  defaultLocalOnly: 'Post to the local timeline only by default',
  enableQuotePost: 'Show Boost/Quote choice when boosting',
  boostOrQuote: 'Boost or quote',
  localOnlyUnsupported: "Your instance doesn't support local-only posts",
  editProfile: 'Edit profile',
  editProfileDisplayName: 'Display name',
  editProfileBio: 'Bio',
  editProfileFields: 'Profile metadata',
  editProfileFieldName: 'Label',
  editProfileFieldValue: 'Content',
  editProfileChangeAvatar: 'Change avatar',
  editProfileChangeHeader: 'Change header',
  editProfileSave: 'Save',
  editProfileSaving: 'Saving…',
  profileUpdated: 'Profile updated',
  profileUpdateFailed: 'Failed to update profile: {error}',
  threadPollingStart: 'Auto-refresh replies (every 30s)',
  threadPollingStop: 'Stop auto-refresh',
  enableDesktopNotifications: 'Enable desktop notifications',
  osNotificationsHeading: 'Push Notifications',
  osNotificationsDescription: 'Get notified on this device, even when Zocial is closed.',
  notifyOnThisDevice: 'Enable OS Push Notifications on this Device',
  notifyOnThisDevicePre: 'Enable',
  notifyOnThisDeviceTrigger: 'OS Push Notifications',
  notifyOnThisDevicePost: 'on this Device',
  deviceNotificationsForegroundOnly: "This server doesn't support background push, so you'll only be notified while Zocial is open in this tab.",
  inAppNotificationsHeading: 'In-App Notifications',
  inAppNotificationsDescription: 'Which activity appears in the notifications tab.',
  notificationSoundHeading: 'Notification Sounds',
  notificationSoundDescription: 'Play a sound when a new notification arrives.',
  notificationSounds: 'Notification Sounds',
  osNotificationsPromptTitle: 'Enable notifications on this device?',
  osNotificationsPromptText: "Get desktop or push notifications on this device when something happens. You can change this anytime in Settings. In-app notifications stay on either way.",
  enableNotifications: 'Enable',
  notNow: 'Not now',
  desktopNotificationsNotSupported: 'Your browser does not support desktop notifications.',
  desktopNotificationsBlocked: 'Desktop notifications are blocked. Please allow them in your browser or system settings.',
  desktopNotificationTitle: 'Zocial',
  desktopNotificationBody: `{count, plural,
    one {1 new notification}
    other {{count} new notifications}
  }`,
  hideFavoriteCount: 'Hide favorite and reaction counts',
  hideReplyCount: 'Hide reply counts',
  hideUnread: 'Hide unread notifications count (i.e. the red dot)',
  disableNotificationSound: 'Disable notification sounds',
  // The quality that makes something seem important or interesting because it seems to be happening now
  immediacy: 'Immediacy',
  showAbsoluteTimestamps: 'Show absolute timestamps (e.g. "March 3rd") instead of relative timestamps (e.g. "5 minutes ago")',
  ui: 'UI',
  language: 'Language',
  interfaceLanguage: 'Interface language',
  composer: 'Composer',
  grayscaleMode: 'Show emojis, images, and videos in grayscale',
  wellnessFooter: `These settings are partly based on guidelines from the
    <a rel="noopener" target="_blank" href="https://humanetech.com">Center for Humane Technology</a>.`,
  // This is a link: "You can filter or disable notifications in the _instance settings_"
  filterNotificationsPre: 'You can filter or disable notifications in the',
  filterNotificationsText: 'instance settings',
  filterNotificationsTextSingle: 'account settings',
  filterNotificationsPost: '',
  // Custom tooltips, like "Disable _infinite scroll_", where you can click _infinite scroll_
  // to see a description. It's hard to properly internationalize, so we just break up the strings.
  disableInfiniteScrollPre: 'Disable',
  disableInfiniteScrollText: 'infinite scroll',
  disableInfiniteScrollDescription: `When infinite scroll is disabled, new posts will not automatically appear at
             the bottom or top of the timeline. Instead, buttons will allow you to
             load more content on demand.`,
  disableInfiniteScrollPost: '',
  // Instance settings
  loggedInAs: 'Logged in as',
  homeTimelineFilters: 'Home timeline filters',
  notificationFilters: 'Notification filters',
  followedHashtags: 'Followed hashtags',
  noFollowedHashtags: 'You don\'t follow any hashtags.',
  addHashtag: 'Follow hashtag',
  pushNotifications: 'Push notifications',
  // Add instance page
  storageError: `It seems Zocial cannot store data locally. Is your browser in private mode
          or blocking cookies? Zocial stores all data locally, and requires LocalStorage and
          IndexedDB to work correctly.`,
  javaScriptError: 'You must enable JavaScript to log in.',
  enterInstanceName: 'Enter instance name',
  instanceColon: 'Instance:',
  // Custom tooltip, concatenated together
  getAnInstancePre: "Don't have an",
  getAnInstanceText: 'instance',
  getAnInstanceDescription: 'An instance is your Mastodon home server, such as mastodon.social or cybre.space.',
  getAnInstancePost: '?',
  joinMastodon: 'Join Mastodon!',
  instancesYouveLoggedInTo: "Instances you've logged in to:",
  addAnotherInstance: 'Add another instance',
  youreNotLoggedIn: "You're not logged in to any instances.",
  currentInstanceLabel: `{instance} {current, select,
    true {(current instance)}
    other {}
  }`,
  // Link text
  logInToAnInstancePre: '',
  logInToAnInstanceText: 'Log in to an instance',
  logInToAnInstancePost: 'to start using Zocial.',
  // Another custom tooltip
  showRingPre: 'Always show',
  showRingText: 'focus ring',
  showRingDescription: `The focus ring is the outline showing the currently focused element. By default, it's only
    shown when using the keyboard (not mouse or touch), but you may choose to always show it.`,
  showRingPost: '',
  instances: 'Instances',
  addInstance: 'Add instance',
  homeTimelineFilterSettings: 'Home timeline filter settings',
  showReblogs: 'Show boosts',
  showReplies: 'Show replies',
  switchOrLogOut: 'Switch to or log out of this instance',
  switchTo: 'Switch to this instance',
  switchToInstance: 'Switch to instance',
  switchToNameOfInstance: 'Switch to {instance}',
  logOut: 'Log out',
  logOutOfInstanceConfirm: 'Log out of {instance}?',
  notificationFilterSettings: 'Notification filter settings',
  // Push notifications
  browserDoesNotSupportPush: "Your browser doesn't support push notifications.",
  deniedPush: 'You have denied permission to show notifications.',
  pushSettings: 'Push notification settings',
  newFollowers: 'New followers',
  reblogs: 'Boosts',
  pollResults: 'Poll results',
  subscriptions: 'Subscribed posts',
  needToReauthenticate: 'You need to reauthenticate in order to enable push notification. Log out of {instance}?',
  failedToUpdatePush: 'Failed to update push notification settings: {error}',
  pushOneAccountPerDevice: 'OS Push Notifications is only allowed for One Account per Device.',
  pushActiveForOtherAccount: 'Currently active for {account}.',
  pushSwitchTitle: 'Move push notifications?',
  pushSwitchText: 'OS push notifications are limited to one account per device. Enable for {to} and turn them off for {from}?',
  pushSwitchConfirm: 'Move',
  pushMovedToast: 'Push notifications moved to {to} — {from} will no longer notify on this device.',
  // Themes
  chooseTheme: 'Choose a theme',
  darkBackground: 'Dark background',
  lightBackground: 'Light background',
  themeLabel: `{label} {default, select,
    true {(default)}
    other {}
  }`,
  animatedImage: 'Animated image: {description}',
  showImage: `Show {animated, select,
    true {animated}
    other {}
  } image: {description}`,
  playVideoOrAudio: `Play {audio, select,
    true {audio}
    other {video}
  }: {description}`,
  accountFollowedYou: '{name} followed you, {account}',
  accountSignedUp: '{name} signed up, {account}',
  accountRequestedFollow: '{name} requested to follow you, {account}',
  accountReported: '{name} filed a report, {account}',
  reblogCountsHidden: 'Boost counts hidden',
  unhandledNotification: 'Unhandled notification type {type}',
  moved: 'moved to',
  bite: 'bit you',
  favoriteCountsHidden: 'Favorite counts hidden',
  reactionCountsHidden: 'Reaction counts hidden',
  rebloggedTimes: `Boosted {count, plural,
    one {1 time}
    other {{count} times}
  }`,
  favoritedTimes: `Favorited {count, plural,
    one {1 time}
    other {{count} times}
  }`,
  reactedTimes: `Reacted to {count, plural,
    one {1 time}
    other {{count} times}
  }`,
  pinnedStatus: 'Pinned post',
  rebloggedYou: 'boosted your post',
  favoritedYou: 'favorited your post',
  reacted: 'reacted with an emoji',
  reactedWith: 'reacted with',
  followedYou: 'followed you',
  edited: 'edited their post',
  requestedFollow: 'requested to follow you',
  reported: 'filed a report',
  signedUp: 'signed up',
  posted: 'posted',
  pollYouCreatedEnded: 'A poll you created has ended',
  pollYouVotedEnded: 'A poll you voted on has ended',
  reblogged: 'boosted',
  // Present-tense verbs used ONLY in the status header ("{account} boosts/replies to {target}").
  // Kept separate from `reblogged`/`replyToLower`, which are reused for the boost confirmation
  // announcement and the boost-of-reply noun ("boosted reply to …") respectively.
  boostsAction: 'boosted',
  repliesTo: 'reply to',
  startedThread: 'started a thread',
  favorited: 'favorited',
  unreblogged: 'unboosted',
  unfavorited: 'unfavorited',
  showSensitiveMedia: 'Show sensitive media',
  hideSensitiveMedia: 'Hide sensitive media',
  clickToShowSensitive: 'Sensitive content. Click to show.',
  longPost: 'Long post',
  // Accessible status labels
  accountRebloggedYou: '{account} boosted your post',
  accountFavoritedYou: '{account} favorited your post',
  accountEdited: '{account} edited their post',
  rebloggedByAccount: '{account} boosted {original}',
  contentWarningContent: 'Content warning: {spoiler}',
  hasMedia: 'has media',
  hasPoll: 'has poll',
  shortStatusLabel: '{privacy} post by {account}',
  // Privacy types
  public: 'Public',
  unlisted: 'Unlisted',
  followersOnly: 'Followers-only',
  direct: 'Direct',
  // Themes
  themeRoyal: 'Light',
  themeScarlet: 'Scarlet',
  themeSeafoam: 'Seafoam',
  themeHotpants: 'Hotpants',
  themeTangerine: 'Tangerine',
  themeOaken: 'Oaken',
  themeMajesty: 'Majesty',
  themeGecko: 'Gecko',
  themeGrayscale: 'Grayscale',
  themeZocial: 'Zocial',
  themeOzark: 'Ozark',
  themeCobalt: 'Cobalt',
  themeSorcery: 'Sorcery',
  themePunk: 'Punk',
  themeEmber: 'Ember',
  themeRiot: 'Riot',
  themeHacker: 'Hacker',
  themeMastodon: 'Mastodon',
  themePitchBlack: 'Pitch Black',
  themeDarkGrayscale: 'Dark Grayscale',
  themeCohostLight: 'Cohost Light',
  // Polls
  voteOnPoll: 'Vote on poll',
  pollChoices: 'Poll choices',
  vote: 'Vote',
  pollDetails: 'Poll details',
  refresh: 'Refresh',
  expires: 'Ends',
  expired: 'Ended',
  voteCount: `{count, plural,
    one {1 vote}
    other {{count} votes}
  }`,
  // Status interactions
  clickToShowThread: '{time} - click to show thread',
  showMore: 'Show more',
  showLess: 'Show less',
  closeReply: 'Close reply',
  cannotReblogFollowersOnly: 'Cannot be boosted because this is followers-only',
  cannotReblogDirectMessage: 'Cannot be boosted because this is a direct message',
  reblog: 'Boost',
  reply: 'Reply',
  replyTo: 'Reply to',
  replyToLower: 'reply to',
  replyToThread: 'Reply to thread',
  favorite: 'Favorite',
  unfavorite: 'Unfavorite',
  // timeline
  loadingMore: 'Loading more…',
  loadMore: 'Load more',
  showCountMore: 'Show {count} more',
  nothingToShow: 'Nothing to show.',
  couldNotLoadAccounts: "Couldn't load this list. Check your connection and try again.",
  accountListUnavailable: "This list isn't available here — the account may keep it private, or your server doesn't have it.",
  accountListPartial: "Showing {shown} of {total} — your server doesn't provide the rest.",
  // status thread page
  statusThreadPage: 'Thread page',
  status: 'Post',
  // toast messages
  blockedAccount: 'Blocked account',
  unblockedAccount: 'Unblocked account',
  unableToBlock: 'Unable to block account: {error}',
  unableToUnblock: 'Unable to unblock account: {error}',
  bookmarkedStatus: 'Bookmarked post',
  unbookmarkedStatus: 'Unbookmarked post',
  unableToBookmark: 'Unable to bookmark: {error}',
  unableToUnbookmark: 'Unable to unbookmark: {error}',
  cannotPostOffline: 'You cannot post while offline',
  cannotPostEmpty: 'Write something or add media before posting.',
  pollNeedsTwoOptions: 'Give your poll at least two non-empty options.',
  unableToPost: 'Unable to post: {error}',
  statusDeleted: 'Post deleted',
  unableToDelete: 'Unable to delete post: {error}',
  cannotFavoriteOffline: 'You cannot favorite while offline',
  cannotUnfavoriteOffline: 'You cannot unfavorite while offline',
  // Custom emoji reactions
  cannotReactWithRemoteEmoji: "Your instance doesn't allow reacting with remote custom emojis",
  tooManyMediaAttachments: 'Only {max} media attachments are allowed',
  // Instance login errors
  alreadyLoggedInTo: 'You are already logged in to {instance}',
  areYouOffline: 'Are you offline?',
  invalidOauthState: 'Invalid OAuth state — please start the login again',
  failedToConnectToInstance: '{error}. Failed to connect to instance.',
  instanceGenericError: `Is this a valid instance? Is a browser extension blocking the request? Are you in private browsing mode? If you believe this is a problem with your instance, please send <a href="https://git.ztfr.eu/Dome/Zocial/src/branch/main/docs/Admin-Guide.md" target="_blank" rel="noopener">this link</a> to the administrator of your instance.`,
  unableToFavorite: 'Unable to favorite: {error}',
  unableToUnfavorite: 'Unable to unfavorite: {error}',
  followedAccount: 'Followed account',
  unfollowedAccount: 'Unfollowed account',
  removeFollowerAccount: 'Remove {account} from followers',
  removeFollowerTitle: 'Remove follower?',
  removeFollowerText: "Remove {account} from your followers? You can't undo this yourself — only they can follow you again.",
  removeFollowerConfirm: 'Remove',
  removedFollower: 'Removed from your followers',
  removeFromFollowersNotSupported: "This server doesn't support removing followers.",
  unableToFollow: 'Unable to follow account: {error}',
  unableToUnfollow: 'Unable to unfollow account: {error}',
  accessTokenRevoked: 'The access token was revoked, logged out of {instance}',
  loggedOutOfInstance: 'Logged out of {instance}',
  failedToUploadMedia: 'Failed to upload media: {error}',
  mutedAccount: 'Muted account',
  unmutedAccount: 'Unmuted account',
  unableToMute: 'Unable to mute account: {error}',
  unableToUnmute: 'Unable to unmute account: {error}',
  mutedConversation: 'Muted conversation',
  unmutedConversation: 'Unmuted conversation',
  unableToMuteConversation: 'Unable to mute conversation: {error}',
  unableToUnmuteConversation: 'Unable to unmute conversation: {error}',
  unpinnedStatus: 'Unpinned post',
  unableToPinStatus: 'Unable to pin post: {error}',
  unableToUnpinStatus: 'Unable to unpin post: {error}',
  unableToRefreshPoll: 'Unable to refresh poll: {error}',
  unableToVoteInPoll: 'Unable to vote in poll: {error}',
  cannotReblogOffline: 'You cannot boost while offline.',
  cannotUnreblogOffline: 'You cannot unboost while offline.',
  failedToReblog: 'Failed to boost: {error}',
  failedToUnreblog: 'Failed to unboost: {error}',
  submittedReport: 'Submitted report',
  failedToReport: 'Failed to report: {error}',
  approvedFollowRequest: 'Approved follow request',
  rejectedFollowRequest: 'Rejected follow request',
  unableToApproveFollowRequest: 'Unable to approve follow request: {error}',
  unableToRejectFollowRequest: 'Unable to reject follow request: {error}',
  searchError: 'Error during search: {error}',
  hidDomain: 'Hid domain',
  unhidDomain: 'Unhid domain',
  unableToHideDomain: 'Unable to hide domain: {error}',
  unableToUnhideDomain: 'Unable to unhide domain: {error}',
  showingReblogs: 'Showing boosts',
  hidingReblogs: 'Hiding boosts',
  unableToShowReblogs: 'Unable to show boosts: {error}',
  unableToHideReblogs: 'Unable to hide boosts: {error}',
  unableToShare: 'Unable to share: {error}',
  unableToSubscribe: 'Unable to subscribe: {error}',
  unableToUnsubscribe: 'Unable to unsubscribe: {error}',
  showingOfflineContent: 'Internet request failed. Showing offline content.',
  youAreOffline: 'You seem to be offline. You can still read posts while offline.',
  // Snackbar UI
  updateAvailable: 'App update available.',
  // Word/phrase filters
  wordFilters: 'Word filters',
  noFilters: 'You don\'t have any word filters.',
  wordOrPhrase: 'Word or phrase',
  contexts: 'Contexts',
  addFilter: 'Add filter',
  addWordFilter: 'Add word filter',
  editFilter: 'Edit filter',
  filterHome: 'Home and lists',
  filterNotifications: 'Notifications',
  filterPublic: 'Public timelines',
  filterThread: 'Conversations',
  filterAccount: 'Profiles',
  filterUnknown: 'Unknown',
  expireAfter: 'Expire after',
  whereToFilter: 'Where to filter',
  irreversible: 'Irreversible',
  wholeWord: 'Whole word',
  save: 'Save',
  updatedFilter: 'Updated filter',
  createdFilter: 'Created filter',
  failedToModifyFilter: 'Failed to modify filter: {error}',
  // Shown when the backend (e.g. GoToSocial) does not support irreversible "drop" filters
  dropFiltersNotSupported: 'This server doesn’t support irreversible (drop) filters. Leave “Irreversible” unchecked to hide matching posts behind a warning instead.',
  deletedFilter: 'Deleted filter',
  required: 'Required',
  // Dialogs
  profileOptions: 'Profile options',
  copyLink: 'Copy link',
  copy: 'Copy',
  emoji: 'Emoji',
  editMedia: 'Edit media',
  shortcutHelp: 'Shortcut help',
  statusOptions: 'Status options',
  confirm: 'Confirm',
  closeDialog: 'Close dialog',
  postPrivacy: 'Post privacy',
  localOnly: 'Local only',
  contentType: 'Content type',
  contentTypeLabel: 'Change content type (currently {label})',
  homeOnInstance: 'Home on {instance}',
  statusesTimelineOnInstance: 'Statuses: {timeline} timeline on {instance}',
  statusesHashtag: 'Statuses: #{hashtag} hashtag',
  statusesThread: 'Statuses: thread',
  statusesAccountTimeline: 'Statuses: account timeline',
  statusesList: 'Statuses: list',
  notificationsOnInstance: 'Notifications on {instance}',
  // Details
  statusEdited: 'Edited',
  // Compose header (edit/reply/quote) + poll choice
  editing: 'Editing',
  replyingTo: 'Replying to',
  quoting: 'Quoting',
  aPost: 'a post',
  aPostBy: 'a post by {handle}',
  dontEdit: 'Don\'t edit',
  dontReply: 'Don\'t reply',
  dontQuote: 'Don\'t quote',
  addPollChoice: 'Add choice',
  postsAndReplies: 'Posts and replies'
}
